'use server';

export async function getOpenAIConfig() {
  return {
    openai_api_key: process.env.OPENAI_API_KEY,
    openai_api_base: process.env.OPENAI_API_BASE,
    openai_model_name: process.env.OPENAI_MODEL_NAME,
  };
}
